import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import Validator from '../../../../Common/validator';
import { isStringValid } from '../../../../Util/stringValidator';
import Waves from 'node-waves'
import NewSuggestSelectInput from '../../../../Common/newSuggestSelectInput';

class CreateProjectForm extends Component{
  constructor(props) {
    super(props);
    const { defaultValue } = this.props;
    this.state = {
      id: defaultValue.id,
      projectNumberSugValue: {name: defaultValue.number, id: null},
      projectNumberTouched: (defaultValue.id!=null),
      projectNameSugValue: {name: defaultValue.name, id: null},
      projectNameTouched: (defaultValue.id!=null)
    }
  }
  onProjectNumberChange = (val) => {
    if(val.id){
      let splitName = val.name.split(" - ");
      this.setState({
        id: val.id,
        projectNameSugValue: {name: splitName[1], id: null},
        projectNumberSugValue: {name: splitName[0], id: null}
      })
    }
    else{
      this.setState({
        id: null,
        projectNumberSugValue: val
      })
    }
  };
  onProjectNameChange = (val) => {
    if(val.id){
      let splitName = val.name.split(" - ");
      this.setState({
        id: val.id,
        projectNameSugValue: {name: splitName[1], id: null},
        projectNumberSugValue: {name: splitName[0], id: null}
      })
    }
    else{
      this.setState({
        id: null,
        projectNameSugValue: val
      })
      if(this.state.projectNumberSugValue.name){
        this.props.isProjectNumberReserved(this.state.projectNumberSugValue.name)
      }
    }
  };
  onProjectNumberBlur = () => {
    if(this.state.projectNumberSugValue.name && this.state.id==null){
      this.props.isProjectNumberReserved(this.state.projectNumberSugValue.name)
    }
    this.setState({
      projectNumberTouched: true
    })
  };
  onProjectNameBlur = () => {
    this.setState({
      projectNameTouched: true
    })
  };
  isValid = () => {
    const { projectNumberSugValue, projectNameSugValue, id } = this.state;
    //set both fields to touched
    //TODO
    this.setState({
      projectNameTouched: true,
      projectNumberTouched: true
    })
    return (
      (isStringValid(projectNumberSugValue.name) &&
       isStringValid(projectNameSugValue.name) &&
       !this.props.projectNumberReserved.reserved) ||
      id!=null)
  };
  componentDidMount = () => {
    Waves.attach('.waves-btn', ['waves-button']);
    Waves.attach('.waves-icon', ['waves-circle']);
  };
  componentDidUpdate = () => {
    Waves.attach('.waves-btn', ['waves-button']);
    Waves.attach('.waves-icon', ['waves-circle']);
  };
  getValues = () => {
    const { projectNumberSugValue, projectNameSugValue, id } = this.state;
    return {
      number: projectNumberSugValue.name,
      name: projectNameSugValue.name,
      id: id
    }
  };
  render()  {
    const { projectNumberReserved, getProjectSuggestions, projectSuggestions } = this.props;
    const { projectNumberSugValue, projectNameTouched, projectNumberTouched, projectNameSugValue, id } = this.state;
    return (
      /* CREATE NEW PROJECT */
      <div>
        <div className="row" style={styles.informationDetailsEdit}>
          <div className="col-xs-8">
            <div style={styles.inputLabel}>Sagsnummer</div>
            <Validator
              isValid={(!projectNumberTouched || (!projectNumberReserved.reserved && isStringValid(projectNumberSugValue.name)) || id!=null)}
              msg={projectNumberReserved.reserved ? "Sagsnummer findes allerede" : "Skal udfyldes"}>
              <NewSuggestSelectInput
                placeholder="Sags nr."
                onChange={this.onProjectNumberChange}
                onQuery={getProjectSuggestions}
                suggestions={projectSuggestions}
                value={projectNumberSugValue}
                onBlur={this.onProjectNumberBlur}
              />
            </Validator>
          </div>
        </div>
        <div style={styles.inputLabel}>Sagsnavn</div>
        <Validator
          isValid={(!projectNameTouched || isStringValid(projectNameSugValue.name))}
          msg={"Skal udfyldes"}>
          <NewSuggestSelectInput
            placeholder="Sags navn"
            onChange={this.onProjectNameChange}
            onQuery={getProjectSuggestions}
            suggestions={projectSuggestions}
            value={projectNameSugValue}
            onBlur={this.onProjectNameBlur}
          />

        </Validator>
      </div>
    );
  }
}


var styles = {
  informationDetailsEdit: {
    paddingBottom: '10px'
  },
  createProjectContainer: {
    lineHeight: '35px',
    textAlign: 'right',
    paddingRight: '38px',
    position: 'relative',
    fontSize: '12px'
  },
  inputLabel: {
    fontSize: '11px'
  }
}

  CreateProjectForm.propTypes = {
    projectNumberReserved: PropTypes.shape({
      projectNumber: PropTypes.string.isRequired,
      reserved: PropTypes.bool.isRequired
    }).isRequired,
    isProjectNumberReserved: PropTypes.func.isRequired,
    defaultValue: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string.isRequired,
      number: PropTypes.string.isRequired
    }),
    getProjectSuggestions: PropTypes.func.isRequired,
    projectSuggestions: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired
    }))
  };

export default Radium(CreateProjectForm)


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/Overview/Helpers/createProjectForm.jsx